import React, { ReactNode } from 'react';
import {
    lighten,
    SxProps,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    useTheme,
} from '@mui/material';
import { InformationTableRow } from '../../molecules/InformationTableRow';

export type InformationTableProps = {
    headers: Array<ReactNode>;
    rows: Array<Array<ReactNode>>;
    cellsSx?: SxProps[];
};

const getKeyFromIndex = (index: number, prefix: string) => `${prefix}-${index}`;

export const InformationTable: React.FunctionComponent<InformationTableProps> = function (props) {
    const { headers, rows, cellsSx } = props;
    const { palette } = useTheme();

    const tableSx = {
        borderCollapse: 'separate',
        borderSpacing: '0 4px',
    };

    const headCelSx = {
        border: 'none',
        padding: '2px 8px',
        lineHeight: '1.6',
        fontWeight: '500',
        fontSize: '13px',
        verticalAlign: 'middle',
        color: lighten(palette.secondary.main, 0.5),
        minWidth: '20px',
    };

    const headerCels = headers.map((header, headerIndex) => (
        <TableCell
            sx={headCelSx}
            key={getKeyFromIndex(headerIndex, 'header')}
        >
            {header}
        </TableCell>
    ));

    const bodyRows = rows.map((items, rowIndex) => (
        <InformationTableRow
            key={getKeyFromIndex(rowIndex, 'row')}
            cels={items}
            cellsSx={cellsSx}
        />
    ));

    return (
        <Table sx={tableSx}>
            <TableHead>
                <TableRow>{headerCels}</TableRow>
            </TableHead>
            <TableBody>{bodyRows}</TableBody>
        </Table>
    );
};
